import { getValue } from "../..//redux/form/form.utils";
import { ERentioFormField } from "../../components/components/Form";
import { ETaskLocation, ETaskType } from "../../types/task.types";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { CONTRACT_SELECT_NONE, EField, } from "./schema.createTask.types";
import { getMappedCategories } from "./schema.createTask.utils";
import { customContractsSelector, customGetContractsActions, customIsFetchingSelector, } from "./schema.createTask.utils.fetchContracts";
// const getCategoryTaskTypeKey = (taskType: ETaskType) =>
//   `${EField.Category}-${taskType}`;
export var getSchema = function (extraData, initialValues) {
    return function (defaultValues) {
        var _a;
        var requiredFields = [EField.Title];
        if (extraData.keypoint) {
            requiredFields.push(EField.Type, EField.PropertySelect, EField.Description);
        }
        // Kind of a hack. There's no way to change the options based on another input
        // So we generate all of the options and hide or show the right input
        // based on the selected other input.
        // const categoriesForTypeFields = Object.values(ETaskType).reduce(
        //   (all: { [key: string]: any }, taskType: ETaskType) => {
        //     // eslint-disable-next-line no-console
        //     console.log("under schema", {
        //       default: getValue(EField.Category, initialValues, defaultValues),
        //     });
        //     const key = getCategoryTaskTypeKey(taskType);
        //     const field = {
        //       default: getValue(EField.Category, initialValues, defaultValues),
        //       //@ts-ignore
        //       options: mappedCategories.map(category => ({
        //         value: getLocalizedText(`task.category.${category.toLowerCase()}`),
        //         id: category,
        //       })),
        //       showIf: (formData: any) => {
        //         // eslint-disable-next-line no-console
        //         console.log("formData in showIf", { formData });
        //         return (
        //           formData[EField.Type] === taskType && mappedCategories.length > 0
        //         );
        //       },
        //     };
        //     all[key] = field;
        //     return all;
        //   },
        //   {},
        // );
        return {
            required: requiredFields,
            properties: (_a = {},
                _a[EField.RecurrenceSelection] = {
                    default: getValue(EField.RecurrenceSelection, initialValues, defaultValues),
                    // @ts-ignore
                    options: [
                        {
                            id: "ONCE",
                            value: getLocalizedText("task.recurring_type.once"),
                        },
                        {
                            id: "RECURRING",
                            value: getLocalizedText("task.recurring_type.recurring"),
                        },
                    ],
                },
                _a[EField.Type] = {
                    default: getValue(EField.Type, initialValues, defaultValues),
                    //@ts-ignore
                    options: Object.values(ETaskType).map(function (type) { return ({
                        value: getLocalizedText("task.type.".concat(type.toLowerCase())),
                        id: type,
                    }); }),
                },
                _a[EField.Category] = {
                    default: getValue(EField.Category, initialValues, defaultValues),
                    //@ts-ignore
                    getOptions: function (formData) {
                        var mappedCategories = getMappedCategories(formData[EField.Type]);
                        return mappedCategories.map(function (category) { return ({
                            value: getLocalizedText("task.category.".concat(category.toLowerCase())),
                            id: category,
                        }); });
                    },
                    // showIf: (formData: any) => {
                    //   // eslint-disable-next-line no-console
                    //   console.log("formData in showIf", { formData });
                    //   return (
                    //     formData[EField.Type] === taskType && mappedCategories.length > 0
                    //   );
                    // },
                },
                _a[EField.Title] = {
                    default: getValue(EField.Title, initialValues, defaultValues),
                    maxLength: 64,
                },
                _a[EField.Description] = {
                    default: getValue(EField.Description, initialValues, defaultValues),
                },
                _a[EField.PropertySelect] = {
                    default: getValue(EField.PropertySelect, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (_) { return !extraData.isGroupActions; },
                },
                _a[EField.ContractSelect] = {
                    default: getValue(EField.ContractSelect, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (formData) {
                        return !!formData[EField.PropertySelect] && !extraData.isGroupActions;
                    },
                },
                _a[EField.ContractBanner] = {
                    default: undefined,
                    // @ts-ignore
                    showIf: function (formData) {
                        return !!formData[EField.PropertySelect] &&
                            !!formData[EField.ContractSelect] &&
                            formData[EField.RecurrenceSelection] === "RECURRING";
                    },
                },
                _a[EField.Location] = {
                    default: getValue(EField.Location, initialValues, defaultValues),
                    //@ts-ignore
                    options: Object.values(ETaskLocation).map(function (location) { return ({
                        value: getLocalizedText("task.location.".concat(location.toLowerCase())),
                        id: location,
                    }); }),
                },
                _a),
        };
    };
};
var getRows = function (extraData) {
    var rows = [
        { col: { width: [1, 1], children: [EField.RecurrenceSelection] } },
        {
            col: { width: [1, 1 / 2], children: [EField.Type] },
        },
        {
            col: {
                width: [1, 1 / 2],
                children: [EField.Category],
            },
        },
        { col: { width: [1, 1], children: [EField.Title] } },
        { col: { width: [1, 1], children: [EField.Description] } },
    ];
    if (!extraData.isGroupActions) {
        rows.push({ col: { width: [1, 1], children: [EField.PropertySelect] } });
        rows.push({ col: { width: [1, 1], children: [EField.ContractSelect] } });
        rows.push({ col: { width: [1, 1], children: [EField.ContractBanner] } });
    }
    rows.push({ col: { width: [1, 1], children: [EField.Location] } });
    return rows;
};
export var uiSchema = function (extraData) {
    var _a;
    return _a = {
            "rentio:navigationTitle": getLocalizedText(extraData.taskId ? "tasks.edit" : "task.new"),
            "rentio:title": getLocalizedText("task.information.section_header"),
            "ui:field": ERentioFormField.Grid,
            grid: {
                row: getRows(extraData),
            }
        },
        _a[EField.RecurrenceSelection] = {
            title: getLocalizedText("task.frequency"),
            "ui:field": ERentioFormField.SegmentedControl,
            formatSummary: function (formData) {
                return getLocalizedText("task.recurring_type.".concat(formData === null || formData === void 0 ? void 0 : formData.toLowerCase()));
            },
            isDisabled: function (formData) { return !!extraData.taskId || extraData.keypoint; },
        },
        _a[EField.Type] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("task.type"),
            formatSummary: function (input) {
                return input ? getLocalizedText("task.type.".concat(input.toLowerCase())) : "";
            },
            optional: !extraData.keypoint,
            isDisabled: function () { return extraData.keypoint; },
        },
        _a[EField.Category] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("task.category"),
            formatSummary: function (input) {
                return input ? getLocalizedText("task.category.".concat(input.toLowerCase())) : "";
            },
            optional: true,
        },
        _a[EField.Title] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("task.subject.label"),
            placeholder: getLocalizedText("task.subject.placeholder"),
            subtitle: getLocalizedText("task.subject.description"),
            autoFocus: true,
        },
        _a[EField.Description] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("system.description"),
            placeholder: getLocalizedText("system.description.placeholder"),
            optional: !extraData.keypoint,
        },
        _a[EField.PropertySelect] = {
            "ui:field": ERentioFormField.PropertySelectInline,
            title: getLocalizedText("choose.property"),
            selectPropertyFromListCtaTitle: undefined,
            optional: !extraData.keypoint,
            valueSelector: function (state, propertyId) {
                var _a;
                if (propertyId) {
                    var property = (_a = state.PROPERTY_V2.detail[propertyId]) === null || _a === void 0 ? void 0 : _a.entity;
                    if (property) {
                        return property.name;
                    }
                    return getLocalizedText("summary.view.property");
                }
                return getLocalizedText("property.no.summary");
            },
        },
        _a[EField.ContractSelect] = {
            "ui:field": ERentioFormField.InlineSelect,
            title: getLocalizedText("task.contract.label"),
            optional: true,
            showIfEmpty: false,
            isDisabled: function (formData) { return !formData[EField.PropertySelect]; },
            // @ts-ignore
            customExtraOptionsSelector: function (state, formData) {
                var propertyId = formData[EField.PropertySelect];
                if (!propertyId)
                    return [];
                return customContractsSelector({ propertyId: propertyId, state: state });
            },
            customIsFetchingSelector: function (state, formData) {
                var propertyId = formData[EField.PropertySelect];
                if (!propertyId)
                    return false;
                return customIsFetchingSelector({ state: state, propertyId: propertyId });
            },
            customGetOptionsActions: customGetContractsActions(EField.PropertySelect),
            emptyMessage: function () { return getLocalizedText("contracts.no.contracts"); },
            valueSelector: function (state, contractId, formData) {
                if (!contractId)
                    return "";
                if (contractId === CONTRACT_SELECT_NONE)
                    return "".concat(getLocalizedText("tasks.create.contract.heading.unspecified"), " (").concat(getLocalizedText("tasks.create.contract.heading.unspecified_message"), ")");
                var propertyId = formData === null || formData === void 0 ? void 0 : formData[EField.PropertySelect];
                if (!propertyId)
                    return contractId;
                var contracts = customContractsSelector({ propertyId: propertyId, state: state });
                var contract = contracts.find(function (c) { return c.id === contractId; });
                if (!contract)
                    return contractId;
                return "".concat(contract.value, " (").concat(contract.subValue, ")");
            },
        },
        _a[EField.ContractBanner] = {
            "ui:field": ERentioFormField.HelpInfo,
            type: "info",
            subtitle: getLocalizedText("task.contract.recurring_banner"),
            showCloseButton: true,
        },
        _a[EField.Location] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("task.location"),
            formatSummary: function (input) {
                return input ? getLocalizedText("task.location.".concat(input.toLowerCase())) : "";
            },
            optional: true,
        },
        _a;
};
